"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = suggestedActions;

var _clearSuggestedActions = require("../actions/clearSuggestedActions");

var _setSuggestedActions = require("../actions/setSuggestedActions");

var DEFAULT_STATE = [];

function suggestedActions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload,
      type = _ref.type;

  switch (type) {
    case _setSuggestedActions.SET_SUGGESTED_ACTIONS:
      if ((payload.suggestedActions || []).length) {
        state = [].slice.call(payload.suggestedActions);
      } else {
        state = DEFAULT_STATE;
      }

      break;

    case _clearSuggestedActions.CLEAR_SUGGESTED_ACTIONS:
      state = DEFAULT_STATE;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9zdWdnZXN0ZWRBY3Rpb25zLmpzIl0sIm5hbWVzIjpbIkRFRkFVTFRfU1RBVEUiLCJzdWdnZXN0ZWRBY3Rpb25zIiwic3RhdGUiLCJwYXlsb2FkIiwidHlwZSIsIlNFVF9TVUdHRVNURURfQUNUSU9OUyIsImxlbmd0aCIsInNsaWNlIiwiY2FsbCIsIkNMRUFSX1NVR0dFU1RFRF9BQ1RJT05TIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUEsSUFBTUEsYUFBYSxHQUFHLEVBQXRCOztBQUVlLFNBQVNDLGdCQUFULEdBQXlFO0FBQUEsTUFBL0NDLEtBQStDLHVFQUF2Q0YsYUFBdUM7O0FBQUE7QUFBQSwwQkFBdEJHLE9BQXNCO0FBQUEsTUFBdEJBLE9BQXNCLDZCQUFaLEVBQVk7QUFBQSxNQUFSQyxJQUFRLFFBQVJBLElBQVE7O0FBQ3RGLFVBQVFBLElBQVI7QUFDRSxTQUFLQywwQ0FBTDtBQUNFLFVBQUksQ0FBQ0YsT0FBTyxDQUFDRixnQkFBUixJQUE0QixFQUE3QixFQUFpQ0ssTUFBckMsRUFBNkM7QUFDM0NKLFFBQUFBLEtBQUssR0FBRyxHQUFHSyxLQUFILENBQVNDLElBQVQsQ0FBY0wsT0FBTyxDQUFDRixnQkFBdEIsQ0FBUjtBQUNELE9BRkQsTUFFTztBQUNMQyxRQUFBQSxLQUFLLEdBQUdGLGFBQVI7QUFDRDs7QUFDRDs7QUFDRixTQUFLUyw4Q0FBTDtBQUNFUCxNQUFBQSxLQUFLLEdBQUdGLGFBQVI7QUFDQTs7QUFDRjtBQUNFO0FBWko7O0FBZUEsU0FBT0UsS0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ0xFQVJfU1VHR0VTVEVEX0FDVElPTlMgfSBmcm9tICcuLi9hY3Rpb25zL2NsZWFyU3VnZ2VzdGVkQWN0aW9ucyc7XG5pbXBvcnQgeyBTRVRfU1VHR0VTVEVEX0FDVElPTlMgfSBmcm9tICcuLi9hY3Rpb25zL3NldFN1Z2dlc3RlZEFjdGlvbnMnO1xuXG5jb25zdCBERUZBVUxUX1NUQVRFID0gW107XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN1Z2dlc3RlZEFjdGlvbnMoc3RhdGUgPSBERUZBVUxUX1NUQVRFLCB7IHBheWxvYWQgPSB7fSwgdHlwZSB9KSB7XG4gIHN3aXRjaCAodHlwZSkge1xuICAgIGNhc2UgU0VUX1NVR0dFU1RFRF9BQ1RJT05TOlxuICAgICAgaWYgKChwYXlsb2FkLnN1Z2dlc3RlZEFjdGlvbnMgfHwgW10pLmxlbmd0aCkge1xuICAgICAgICBzdGF0ZSA9IFtdLnNsaWNlLmNhbGwocGF5bG9hZC5zdWdnZXN0ZWRBY3Rpb25zKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHN0YXRlID0gREVGQVVMVF9TVEFURTtcbiAgICAgIH1cbiAgICAgIGJyZWFrO1xuICAgIGNhc2UgQ0xFQVJfU1VHR0VTVEVEX0FDVElPTlM6XG4gICAgICBzdGF0ZSA9IERFRkFVTFRfU1RBVEU7XG4gICAgICBicmVhaztcbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICByZXR1cm4gc3RhdGU7XG59XG4iXX0=